
import EoIcon, { EoIconOptions } from '../EoIcon/EoIcon'
import EoImg from '../EoImg/EoImg'

export default {
  name: 'EoListItem',
  components: {
    EoIcon,
    EoImg,
  },
  props: {
    /**
     * Hyperlink to url, page or anchor tag
     */
    to: {
      type: String,
      default: null,
    },
    /**
     * Prefetches the page behind the link
     */
    prefetch: {
      type: Boolean,
      default: true,
    },
    /**
     * Target for the link: (_self) (_blank)
     */
    target: {
      type: String,
      default: '_self',
    },
    /**
     * Image source OR source set
     */
    image: {
      type: String,
      default: null,
    },
    /**
     * Icon to show on top of the image
     */
    icon: {
      type: String,
      default: null,
    },
    /**
     * Color of the icon to show on top of the image
     */
    iconColor: {
      type: String,
      default: null,
    },
    /**
     * Title
     */
    title: {
      type: String,
      default: null,
    },
    /**
     * Make title bold
     */
    titleProminent: {
      type: Boolean,
      default: false,
    },
    /**
     * Subtitle
     */
    subtitle: {
      type: String,
      default: null,
    },
    /**
     * Icon in front of the subtitle
     */
    subtitleIcon: {
      type: String,
      validator: prop => EoIconOptions().includes(prop),
      default: null,
    },
    /**
     * Show subtitle above title
     */
    subtitleFirst: {
      type: Boolean,
      default: false,
    },
    /**
     * Number of lines to truncate (must be greater or equal to 1)
     */
    titleLines: {
      type: [String, Number],
      default: null,
      validator: (value) => {
        if (Number(value)) {
          return Number(value) >= 1
        }
        return true
      },
    },
  },
  data () {
    return {
      index: null,
    }
  },
  computed: {
    classes () {
      return {
        'eo-list-item': true,
        'is-title-prominent': this.titleProminent,
        'is-subtitle-first': this.subtitleFirst,
      }
    },
    dynamicLinkTag () {
      if (this.to) {
        if (
          this.to.startsWith('https://') ||
          this.to.startsWith('http://') ||
          this.to.startsWith('tel:') ||
          this.to.startsWith('mailto:') ||
          this.to.startsWith('whatsapp:') ||
          this.to.startsWith('#') ||
          this.target.toLowerCase() === '_parent' ||
          this.target.toLowerCase() === '_top'
        ) {
          return 'a'
        }
        if (this.$root.$options.components.NuxtLink) {
          return 'nuxt-link'
        } else if (this.$root.$options.components.RouterLink) {
          return 'router-link'
        } else {
          return 'a'
        }
      }
      return 'button'
    },
    href () {
      if (this.dynamicLinkTag === 'a' || this.dynamicLinkTag === 'nuxt-link' || this.dynamicLinkTag === 'router-link') {
        return this.to || null
      } else {
        return null
      }
    },
  },
}
